import React from 'react';
import { Paper, Box, Tabs, Tab } from '@mui/material';
import TabPanel from '../../../components/common/tabs/TabPanel';
import ProjectFileTemplate from '../../../components/projectmng/stepper/ProjectFileTemplate';
import EstimateTemplate from '../../../components/projectmng/stepper/EstimateTemplate';
import ObtainorderTemplate from '../../../components/projectmng/stepper/ObtainorderTemplate';
import TechSupportTemplate from '../../../components/projectmng/stepper/TechSupportTemplate';
import PurchaseOrderTemplate from '../../../components/projectmng/stepper/PurchaseOrderTemplate';
import ProjectDetailInfoContainer from '../detail/ProjectDetailInfoContainer';
import OrderSheetSentTemplate from '../../../components/projectmng/stepper/OrderSheetSentTemplate';
import PurchaseBillRegisterTemplate from '../../../components/projectmng/stepper/PurchaseBillRegisterTemplate';
import SalesBillConfirmReqTemplate from '../../../components/projectmng/stepper/SalesBillConfirmReqTemplate';

function a11yProps(index) {
  return {
    id: `project-tab-${index}`,
    'aria-controls': `project-tabpanel-${index}`,
  };
}

const ProjectOrderContainer = ({ activeTap, handleTabChange, stepperRef }) => {
  return (
    <Paper
      sx={{
        mt: 1,
        pb: 1,
      }}
    >
      <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTap}
          onChange={handleTabChange}
          aria-label="프로젝트"
        >
          <Tab label="기본사항" {...a11yProps(0)} />
          <Tab label="매입견적서" {...a11yProps(1)} />
          <Tab label="견적서" {...a11yProps(2)} />
          <Tab label="수주품의서" {...a11yProps(3)} />
          <Tab label="기술지원요청서" {...a11yProps(4)} />
          <Tab label="받은 발주서" {...a11yProps(5)} />
          <Tab label="보낸 발주서" {...a11yProps(6)} />
          <Tab label="매입 계산서 등록" {...a11yProps(7)} />
          <Tab label="매출 계산서 발행요청서" {...a11yProps(8)} />
        </Tabs>
      </Box>
      <TabPanel value={activeTap} index={0}>
        <ProjectDetailInfoContainer stepperRef={stepperRef} />
      </TabPanel>
      <TabPanel value={activeTap} index={1}>
        <ProjectFileTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={2}>
        <EstimateTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={3}>
        <ObtainorderTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={4}>
        <TechSupportTemplate />
      </TabPanel>

      <TabPanel value={activeTap} index={5}>
        <PurchaseOrderTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={6}>
        <OrderSheetSentTemplate />
      </TabPanel>

      <TabPanel value={activeTap} index={7}>
        <PurchaseBillRegisterTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={8}>
        <SalesBillConfirmReqTemplate />
      </TabPanel>

      <Box sx={{ width: '100%', borderTop: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTap}
          onChange={handleTabChange}
          aria-label="프로젝트"
          TabIndicatorProps={{ style: { top: 0 } }}
        >
          <Tab label="기본사항" {...a11yProps(0)} />
          <Tab label="매입견적서" {...a11yProps(1)} />
          <Tab label="견적서" {...a11yProps(2)} />
          <Tab label="수주품의서" {...a11yProps(3)} />
          <Tab label="기술지원요청서" {...a11yProps(4)} />
          <Tab label="받은 발주서" {...a11yProps(5)} />
          <Tab label="보낸 발주서" {...a11yProps(6)} />
          <Tab label="매입 계산서 등록" {...a11yProps(7)} />
          <Tab label="매출 계산서 발행요청서" {...a11yProps(8)} />
        </Tabs>
      </Box>
    </Paper>
  );
};

export default ProjectOrderContainer;
